import { Injectable }       from '@angular/core';
import {
  CanActivate, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild
}                           from '@angular/router';

import { LoginService} from './Services/login.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private loginService: LoginService) {}

  canActivate() {
    console.log('AuthGuard#canActivate called');
    if (this.loginService.IsUserAdmin()) {
        console.log("user is admin");
        return true;
    }
    console.log("user isn't admin");
    return false;
  }
}




// WEBPACK FOOTER //
// ./src/app/admin.auth.service.ts